import { batchCustomsForms } from './batch-customs-forms';
import { batchLabels } from './batch-labels';
import { batchPackingSlip } from './batch-packing-slip';
import { customsForms } from './customs-forms';
import { endOfDayForm } from './end-of-day-form';
import { hotkeysAndBarcode } from './hotkeys-and-barcode';
import { label } from './label';
import { orderSummary } from './order-summary';
import { packingSlip } from './packing-slip';
import { pickList } from './pick-list';
import { batchPickList } from './batch-pick-list';
import { shipmentManifest } from './shipment-manifest';
import { batchShipmentManifest } from './batch-shipment-manifest';
import { otherForms } from './other-forms';
import { purchaseOrder } from './purchase-order';
import { locationBarcode } from './location-barcode';
import { uomBarcode } from './uom-barcode';

export const DocumentTypeEpicHelpers = [
  batchCustomsForms,
  batchLabels,
  batchPackingSlip,
  customsForms,
  endOfDayForm,
  hotkeysAndBarcode,
  label,
  orderSummary,
  packingSlip,
  pickList,
  batchPickList,
  shipmentManifest,
  batchShipmentManifest,
  otherForms,
  purchaseOrder,
  locationBarcode,
  uomBarcode,
];
